<!--
    描述：左侧项目结构树
    时间：2020-05-19
    Created by ws
-->
<template>
	<div class="w-strucutre-layout" :class="[costFiles ? 'costfilesHeight' : '']">
		<div class="w-strucutre-header">
			<div class="left-text">
				<span>项目结构</span>
			</div>

			<div class="btnGroups">
				<el-select v-model="curLevel" class="ml10 select-width" placeholder="请选择" size="small" @change="onChangeLevel">
					<el-option :value="0" label="展开到一级"></el-option>
					<el-option :value="1" label="展开到二级"></el-option>
					<el-option :value="2" label="展开到三级"></el-option>
					<!-- <el-option :value="3"
							   label="展开到四级"></el-option> -->
				</el-select>
				<template v-if="!hideBtn">
					<el-button
						size="small"
						type="primary"
						class="ml5"
						v-if="roleBtns.includes('structure-edit') || curSource === '1'"
						@click.native="openEditDialog"
						>编辑
					</el-button>
					<el-button class="ml5" size="small" type="primary" v-if="roleBtns.includes('add-tag')" @click="showTagsDialog('add')"
						>添加标签</el-button
					>
					<el-button plain size="small" @click="doTem">导入模板</el-button>
				</template>
			</div>
		</div>

		<div class="w-structure-content">
			<!-- 树形表格 -->
			<div class="h100" ref="tableContent">
				<el-table
					:data="tableData"
					ref="structureTree"
					row-key="id"
					border
					stripe
					v-loading="loading"
					:height="tableH"
					show-overflow
					highlight-current-row
					:expand-row-keys="expandKeys"
					:row-class-name="rowClassName"
					:tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
					@row-click="rowClick"
				>
					<el-table-column type="action" width="55" align="center" v-if="showCheckbox">
						<template slot="header" slot-scope="scope">
							<el-checkbox v-model="checkAll" @change="handleCheckAll"></el-checkbox>
						</template>
						<template slot-scope="scope">
							<el-checkbox
								@change="handleCheck($event, scope.row)"
								v-model="scope.row.isChecked"
								:true-label="1"
								:false-label="0"
								v-if="scope.row.levelType !== 0"
							></el-checkbox>
							<!-- <div v-else></div> -->
						</template>
					</el-table-column>
					<el-table-column prop="sname" label="项目名称" min-width="180">
						<template slot-scope="scope">
							<el-tooltip class="item" effect="dark" :content="scope.row.sname" placement="right">
								<span class="text-overflow" :class="scope.row.levelType === 0 ? 'cell-text' : 'cell-tooltip'">{{
									scope.row.levelType === 0 ? scope.row.sname : ''
								}}</span>
							</el-tooltip>
						</template>
					</el-table-column>
					<el-table-column prop="singleName" label="单项工程名称" show-overflow-tooltip min-width="150">
						<template slot-scope="scope">
							{{ scope.row.levelType === 1 ? scope.row.sname : '' }}
							<el-tooltip placement="right" effect="light" v-if="scope.row.tags && scope.row.tags !== ''">
								<div slot="content" class="tag-label-tooltip">
									<el-tag class="mr10 mb10" size="mini" v-for="(item, index) in toArray(scope.row.tags)" :key="index">{{
										item
									}}</el-tag>
								</div>
								<svg-icon icon-class="biaoqian" class="ml5"></svg-icon>
							</el-tooltip>
						</template>
					</el-table-column>
					<el-table-column prop="unitName" min-width="180" label="单位工程名称" show-overflow-tooltip>
						<template slot-scope="scope">{{ scope.row.levelType === 2 ? scope.row.sname : '' }}</template>
					</el-table-column>
				</el-table>
			</div>
		</div>

		<!-- 编辑弹窗 -->
		<el-dialog :title="dialogObj.title" :visible.sync="dialogObj.visible" :width="dialogObj.width" :close-on-click-modal="false">
			<template slot="title">
				<span class="title-text">{{ dialogObj.title }}</span>
				<el-button class="title-btn" type="primary" size="mini" @click="getXml">获取 xml文件项目结构</el-button>
			</template>

			<!-- 编辑树结构 -->
			<div class="h100">
				<!-- 树主体 -->
				<dialog-tree
					v-if="dialogObj.visible"
					:existData="tableData"
					ref="dialogTree"
					@onSuccess="handleClose"
					@onCancel="handleClose"
					@onDefault="doCancel"
				></dialog-tree>
			</div>

			<div slot="footer" class="dialog-footer text-center">
				<el-button @click="dialogObj.visible = false" size="small">取 消 </el-button>
				<el-button type="primary" size="small" :loading="btnLoading" @click="doConfirm">确 定</el-button>
			</div>
		</el-dialog>

		<!-- 上传弹窗 -->
		<el-dialog title="上传文件" :visible.sync="uploadDialog.visible" width="600px">
			<my-upload mode="add" ref="myUpload" :multiple="false" :maxNum="1" :acceptType="acceptType"></my-upload>

			<div slot="footer" class="dialog-footer text-center">
				<el-button @click="uploadDialog.visible = false" size="small">取 消 </el-button>
				<el-button type="primary" size="small" :loading="uploadDialog.btnLoading" @click="doParse">确 定</el-button>
			</div>
		</el-dialog>

		<!-- 添加标签 -->
		<AddLabelDialog
			:isShowDialog="tagsDialog.visible"
			:curRowId="curRowId"
			:curRowName="curRowName"
			@close-dialogStatus="close_dialog"
			:dialogData="dialogData"
			tagFor="1056003"
		></AddLabelDialog>

		<!-- 导入模板弹窗 -->
		<el-dialog
			:before-close="exportDialogClose"
			class="custom-dialog"
			top="7vh"
			:close-on-click-modal="false"
			:destory-on-close="true"
			:title="exportDialogObj.title"
			:visible.sync="exportDialogObj.show"
			width="800px"
		>
			<el-form :model="temForm" ref="temForm" class="mt20" label-width="120px" :show-message="false">
				<el-form-item label="文件" required>
					<my-upload :aid="aid" mode="add" ref="myUpload" :multiple="false" :maxNum="1" :acceptType="['xls', 'xlsx']"></my-upload>
				</el-form-item>
			</el-form>
			<div slot="footer" class="text-center">
				<el-button @click="exportDialogClose">取 消</el-button>
				<el-button type="primary" @click="exportDialogSubmit" :loading="exportDialogObj.loading">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import { getStructureData, xmlToStructure } from '@/api/modules/dataProject.js'
import { importBasicInfo } from '@/api/modules/analysis.js'
import { mapState } from 'vuex'
import dialogTree from './dialog_tree'
import myUpload from 'components/upload/upload'
import AddLabelDialog from '@/components/addTag/AddLabelDialog'
import * as API from '@/api/modules/home'

export default {
	components: {
		dialogTree,
		myUpload,
		AddLabelDialog
	},
	props: {
		costFiles: {
			//造价概算传值
			type: String,
			default: ''
		},
		// 是否显示编辑按钮
		editable: {
			type: Boolean,
			default: true
		},
		// 是否显示 多选框
		showCheckbox: {
			type: Boolean,
			default: false
		},
		// 是否不可编辑
		hideBtn: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			loading: false,
			curLevel: 1,
			tableData: [],
			staticData: [],
			expandKeys: [],
			tableH: 0,
			dialogObj: {
				title: '项目结构树编辑',
				visible: false,
				width: '800px',
				type: 'edit'
			},
			checkedList: [],
			btnLoading: false,
			timer: null,
			checkAll: false,
			// 上传弹窗
			uploadDialog: {
				visible: false,
				btnLoading: false
			},
			curRowId: '', // 当前行数据的id
			curRowName: '', //当前行项目名称
			activeRow: {},
			tagsDialog: {
				visible: false,
				width: '800px',
				title: '添加标签',
				type: '',
				module: 'tag'
			},
			dialogData: {},
			tagList: [],
			exportDialogObj: {
				title: '导入模板',
				show: false,
				loading: false
			},
			aid: '',
			temForm: {}
		}
	},
	created() {
		if (this.curProjectId) {
			this.getTreeData()
		}

		this.$nextTick(() => {
			this.tableH = this.$refs.tableContent.offsetHeight
		})
	},
	methods: {
		// 获取结构树 数据
		getTreeData() {
			this.tableData = []
			getStructureData({ id: this.curProjectId })
				.then((res) => {
					if (res.code === 0) {
						// debugger
						let _node = this.$utils.findTree([res.data], (x) => x.levelType === 2)
						if (!_node) {
							this.$message.warning('请先完善项目结构！')
						}
						// 改造数据
						res.data.pid = '0'
						res.data.levelTypeCode = '0'

						if (res.data.children && res.data.children.length > 0) {
							res.data.children.forEach((x, index) => {
								x.pid = res.data.id
							})
						}

						// 默认选择第一个
						if (this.showCheckbox && res.data.children[0] && res.data.children[0].children[0]) {
							res.data.children[0].children[0].isChecked = 1
						}

						this.tableData.push(res.data)
						this.staticData = this.tableData

						// 设置高亮
						if (this.$refs.structureTree) {
							this.onChangeLevel(1)
							setTimeout(() => {
								this.$refs.structureTree.setCurrentRow(res.data)
							}, 500)

							this.rowClick(res.data, null, null, true)
						}

						setTimeout(() => {
							if (this.showCheckbox && res.data.children[0] && res.data.children[0].children[0]) {
								this.handleCheck(true, this.tableData[0].children[0].children[0])
							}
						}, 500)
					}
				})
				.catch((err) => {})
		},

		// 行样式
		rowClassName({ row, rowIndex }) {
			if (row.levelType === 0) {
				return 'project-row'
			} else if (row.levelType === 1) {
				return 'single-row'
			} else if (row.levelType === 2) {
				return 'unit-row'
			}
			return ''
		},

		// 行点击事件
		rowClick(row, column, event, first) {
			if (!first) {
				this.curRowId = row.id
				this.activeRow = row
			}
			if (row && row.id) {
				this.$emit('rowClick', row)
			}
		},

		// 点击全选
		handleCheckAll(val) {
			// val 全选 否则 全不选
			this.$utils.eachTree(this.tableData, (x) => (x.isChecked = val ? 1 : 0))

			this.shakeDelay()
		},

		// 多选事件
		handleCheck(val, row) {
			let _parent = this.$utils.findTree(this.tableData, (x) => x.id === row.pid)?.item || null

			// 关联父级
			if (_parent && _parent.children) {
				let _check = _parent.children.find((x) => x.isChecked === 0)
				_parent.isChecked = _check ? 0 : 1
			}

			// 关联子级
			if (row.children && row.children.length > 0) {
				this.$utils.eachTree([row], (x) => (x.isChecked = val))
			}

			// 全部待选中
			let allList = this.$utils.filterTree(this.tableData, (x) => x.levelType === 2)

			// 当前已选中
			let curList = this.$utils.filterTree(this.tableData, (x) => x.isChecked === 1 && x.levelType === 2)

			// 设置全选
			if (curList.length === allList.length) {
				this.checkAll = true
				this.tableData[0].isChecked = 1
			}

			// 取消全选
			if (this.checkAll && !val) {
				this.checkAll = false
				this.tableData[0].isChecked = 0
			}

			// 函数调用
			this.shakeDelay()
		},

		// 点击切换展开层级
		onChangeLevel(val) {
			this.loading = true
			// 先清空
			this.tableData = []
			this.expandKeys = []

			// 设置 level
			let _data = JSON.parse(JSON.stringify(this.staticData))
			this.expandLevel(_data, val, this.expandKeys)

			// 展示表格
			setTimeout(() => {
				this.loading = false
				this.tableData = this.staticData
				this.$refs.structureTree ? this.$refs.structureTree.doLayout() : ''
			}, 500)
		},

		// 默认key 值展开
		expandLevel(arr, level, backArr) {
			if (arr.length > 0) {
				arr.forEach((x) => {
					if (x.children && x.levelType < level) {
						backArr.push(x.id)
						this.expandLevel(x.children, level, backArr)
					}
				})
			}
		},

		// 防抖事件
		shakeDelay() {
			// 如果此时定时器在， 清除
			if (this.timer) {
				clearTimeout(this.timer)
			}

			let list = this.$utils.filterTree(this.tableData, (x) => x.isChecked === 1 && x.levelType === 2)

			let arr = list.map((x) => x.id)

			// 没继续点击后 做操作处理
			this.timer = setTimeout(() => {
				this.$emit('onCheck', arr)
			}, 1200)
		},

		// 点击确定 保存结构树编辑
		doConfirm() {
			this.btnLoading = true
			this.$refs.dialogTree.doSave()
		},

		// 确定回调
		onSuccess() {
			// 关闭弹窗
			this.dialogObj.visible = false
		},

		// 打开编辑弹窗
		openEditDialog() {
			this.dialogObj.title = '项目结构树编辑'
			this.dialogObj.type = 'edit'
			this.dialogObj.width = '1000px'
			this.dialogObj.visible = true
		},

		// 关闭弹窗的事件
		handleClose() {
			this.dialogObj.visible = false
			this.dialogObj.type = 'edit'
			this.btnLoading = false
			// 刷新结构树
			this.getTreeData()
		},

		// 未保存时回调
		doCancel() {
			setTimeout(() => {
				this.btnLoading = false
			}, 2000)
		},

		// 获取xml 文件
		getXml() {
			this.uploadDialog.visible = true
		},

		// 上传弹窗 确认解析
		doParse() {
			this.uploadDialog.btnLoading = true
			let arr = this.$refs.myUpload.addList

			if (arr.length === 0) {
				this.$message.warning('请上传要解析的xml 文件!')
				this.uploadDialog.btnLoading = false
				return
			}

			let formData = new FormData()
			for (let item of arr) {
				formData.append('file', item)
			}
			formData.append('fileType', 0) // 0 xml  1 excel
			formData.append('projectId', this.curProjectId)

			// 保留签证类型
			let list = this.$refs.dialogTree.treeData
			let _item = this.$utils.findTree(list, (x) => x.isSpe === 1)

			xmlToStructure(formData)
				.then((res) => {
					this.uploadDialog.btnLoading = false
					// 改造数据
					res.data.param.pid = '0'
					res.data.param.levelTypeCode = '0'

					this.$refs.dialogTree.treeData = [res.data.param]
					_item ? this.$refs.dialogTree.treeData[0].children.push(_item.item) : ''

					this.uploadDialog.visible = false
				})
				.catch((err) => {
					this.uploadDialog.btnLoading = false
				})
		},

		/************ 添加标签 ************/
		// 行点击事件
		currentRow(row) {
			this.curRowId = row.id
		},

		// 展示标签弹窗
		showTagsDialog(type) {
			if (this.curRowId === '') {
				this.$message.warning('请先选择要添加标签的单项项目！')
				return
			}
			if (this.activeRow.levelType !== 1) {
				this.$message.warning('此处只能给单项工程添加标签！')
				return
			}

			switch (type) {
				case 'add':
					// 新增
					let params = {
						objectId: this.curRowId,
						applys: '1056003',
						createUserid: this.userInfo.id
					}

					API.getObjectTags(params).then((res) => {
						let { privateExsitTags, platTags, privateTags } = res.data
						this.originalTags = this.$utils.clone(privateExsitTags, true)
						// 已选择标签
						this.selectedTags = privateExsitTags

						// 所有标签集合
						this.allTags = [...platTags, ...privateTags]
						this.dialogData = {
							originalTags: this.originalTags,
							selectedTags: this.selectedTags,
							allTags: this.allTags
						}
					})
					break
				case 'view':
					break
			}
			this.tagsDialog.visible = true
			this.tagsDialog.type = type
		},

		close_dialog(val) {
			this.tagsDialog.visible = false
			this.curRowId = ''
			if (val) {
				this.activeRow = {}
				this.getTreeData()
			}
		},

		// 展示标签
		toArray(str) {
			let arr = str.split(',').filter((x) => x !== '')
			return arr
		},

		// 导入模板
		doTem() {
			this.exportDialogObj.show = true
		},

		// 弹窗确认
		exportDialogSubmit() {
			this.exportDialogObj.loading = true
			let _addList = this.$refs.myUpload.addList
			if (_addList.length === 0) {
				this.$message.warning('请上传具体的文件!')
				this.exportDialogObj.loading = false
				return
			}
			let formData = new FormData()
			for (let item of _addList) {
				formData.append('file', item)
			}
			importBasicInfo(formData)
				.then((res) => {
					this.getTreeData()
					this.exportDialogClose()
				})
				.finally((err) => {
					this.exportDialogObj.loading = false
				})
			return
		},

		// 弹窗关闭
		exportDialogClose() {
			this.exportDialogObj = { title: '导入模板', show: false, loading: false }
		}
	},
	computed: {
		// 当前的 项目来源：'0' 是造价系统的， '1' 是审计系统推送的
		curSource() {
			return this.$route.query.source || '0'
		},
		...mapState('app', {
			clientSize: (state) => state.clientSize
		}),
		...mapState('menu', {
			roleBtns: (state) => state.roleBtns
		}),
		...mapState('user', {
			userInfo: (state) => state.userInfo
		}),
		// 当前的 项目Id
		curProjectId() {
			return this.$route.query.projectId
		},

		// 文件上传 文件类型
		acceptType() {
			return ['xml', 'XML']
		}
	},
	watch: {
		// 页面大小变化
		clientSize(obj) {
			this.$nextTick(() => {
				this.tableH = this.$refs.tableContent.offsetHeight
			})
		},
		// 监听项目ID 的变化
		curProjectId() {
			setTimeout(() => {
				this.getTreeData()
			}, 300)

			this.$nextTick(() => {
				this.tableH = this.$refs.tableContent.offsetHeight
			})
		}
	}
}
</script>

<style scoped lang="less">
/deep/ .el-table__body tr.current-row td {
	background-color: #dcbf5f !important;
}

.select-width {
	width: 150px;
}

.title-text {
	font-size: 18px;
}
.title-btn {
	float: right;
	margin-right: 40px;
}
</style>
